import { useEffect, useState } from 'react';
import { useAuthenticationProvider } from '../../../authentication/authProvider';
import ConfirmModal from '../../confirmationmodal/confirmationModal';
import { Logout } from '../../icons';
import { useTranslation } from 'react-i18next';
import { Button, Radio, RadioGroup } from '../../Ant';
import { Flex } from 'antd';
import { getFormatedOrganisationList } from '../../../constants/utilityFunctions';
import OrganisationRadioCard from '../../common/organisationRadioCard';

const SelectionList = ({
  organisationList,
  handleSelectOrganisation,
  setSelectOrganisation,
  selectOrganisation,
}: {
  organisationList: IOrganisation[];
  handleSelectOrganisation: () => void;
  setSelectOrganisation: (value: IOrganisation) => void;
  selectOrganisation?: IOrganisation;
}) => {
  const { t } = useTranslation();

  const { logout } = useAuthenticationProvider();
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [isLogoutModalVisible, setIsLogoutModalVisible] = useState<boolean>(false);

  useEffect(() => {
    if (selectOrganisation) {
      setSelectedValue(selectOrganisation.organizationName);
    }
  }, [selectOrganisation]);

  const formattedList = getFormatedOrganisationList(organisationList);

  const handleLogout = () => {
    logout();
    setIsLogoutModalVisible(false);
  };

  return (
    <>
      {/* The list scrolls while the buttons stay put, so the scrollbar strip is reclaimed on the
          list itself — reserving it on this wrapper would leave the cards short on their right.
          It takes the room left beside the logged-in user row above it, which `h-full` would
          overshoot by that row's height and push the buttons off the bottom of the pane. */}
      <div
        data-testid="organisation-selection-list"
        className="selection-list flex-grow min-h-0 d-flex fd-column jc-space-between gap-15"
      >
        <RadioGroup
          data-testid="organisation-selection-radio-group"
          value={selectedValue}
          onChange={(e) => {
            setSelectedValue(e.target.value);
            const selectedItem = formattedList.find(
              (item) => item.organizationName === e.target.value,
            );
            if (selectedItem) {
              setSelectOrganisation(selectedItem);
            }
          }}
          className="d-flex fd-column gap-10 overflow-y-auto scroll-stable-gutter"
        >
          {formattedList.map((item) => (
            <Radio
              data-testid={`organisation-radio-${item?.organizationName}`}
              key={item.organizationName}
              value={item.organizationName}
              disabled={!item.isOperational}
            >
              <OrganisationRadioCard organisation={item} />
            </Radio>
          ))}
        </RadioGroup>
        <Flex className="w-full" align="center" gap={5}>
          <Button
            icon={<Logout />}
            onClick={() => {
              setIsLogoutModalVisible(true);
            }}
            size="large"
            block
            maxwidth="120px"
            className="logout-btn"
          >
            {t('common:logout')}
          </Button>
          <Button
            type="primary"
            onClick={() => handleSelectOrganisation()}
            size="large"
            block
            data-testid="select-organisation-button"
            disabled={!selectOrganisation}
          >
            {t('common:select')}
          </Button>
        </Flex>
      </div>
      <ConfirmModal
        visible={isLogoutModalVisible}
        onClose={() => setIsLogoutModalVisible(false)}
        icon={<Logout />}
        title={t('common:logOutQuestion')}
        subtitle={t('common:logOutMessage')}
        cancelText={t('common:cancel')}
        confirmText={t('common:logOutBtnText')}
        onConfirm={handleLogout}
      />
    </>
  );
};

export default SelectionList;
